import _ from "lodash"

export const getPaymentItems  = state => _.get(state,['payment','amount','items'],null)
export const getPaymentTotal  = state => _.get(state,['payment','amount','total'],0)
export const getPaymentTotalAmount  = state => _.get(state,['payment','amount','totalAmount'],0)
export const getPaymentCurrency = state => _.get(state,['payment','amount','currency'],'')

export const getPaymentConfigData = state => _.get(state,['payment','paymentConfig'],null)


export const getPaymentConfigFpxBanks = paymentConfig => _.get(paymentConfig,['fpx_banks'],[])
export const getPaymentConfigAttributes = paymentConfig => _.get(paymentConfig,['attributes'],[])
export const getPaymentIsOperate = paymentConfig => _.get(paymentConfig,['attributes', 'is_operate'],[])
export const getPaymentIsOperateCutOffTime = paymentConfig => _.get(paymentConfig,['attributes', 'cutoff_time'],[])


//payment detail
export const getPaymentDetailAdditionalCharges = paymentDetail => _.get(paymentDetail,['additional_charges','full_text'],'')
export const getPaymentDetailContracts = paymentDetail => _.get(paymentDetail,['contracts'],[])
export const getPaymentDetailCDSBranchCode = paymentDetail => _.get(paymentDetail,['cds_branch_code'],'')
export const getPaymentDetailCDSNumber = paymentDetail => _.get(paymentDetail,['cds_number'],'')
export const getPaymentDetailClientCode = paymentDetail => _.get(paymentDetail,['client_code'],'')
export const getPaymentDetailClientRemarks = paymentDetail => _.get(paymentDetail,['client_remarks'],'')
export const getPaymentDetailCreatedAtText = paymentDetail => _.get(paymentDetail,['transaction_date','text'],'')
export const getPaymentDetailCreatedAtDateTimeText = paymentDetail => _.get(paymentDetail,['transaction_datetime','text'],'')
export const getPaymentDetailDepositAmountFullText = paymentDetail => _.get(paymentDetail,['deposit_amount','full_text'],'')
export const getPaymentDetailPaymentAmountFullText = paymentDetail => _.get(paymentDetail,['payment_amount','full_text'],'')
export const getPaymentDetailID = paymentDetail => _.get(paymentDetail,['id'],'')
export const getPaymentDetailReference = paymentDetail => _.get(paymentDetail,['reference'],'')
export const getPaymentDetailStatusText = paymentDetail => _.get(paymentDetail,['status','text'],'')
export const getPaymentDetailStatusValue = paymentDetail => _.get(paymentDetail,['status','value'],'')
export const getPaymentDetailTotalFullText = paymentDetail => _.get(paymentDetail,['total','full_text'],'')
export const getPaymentDetailTypeText = paymentDetail => _.get(paymentDetail,['type','text'],'')
export const getPaymentDetailAction = paymentDetail => _.get(paymentDetail,['action','value'],'')
export const getPaymentManualPaymentItems = (paymentDetail) => _.get(paymentDetail, ["manual_payment_items"], []);
export const getPaymentOnlinePaymentItems = (paymentDetail) => _.get(paymentDetail, ["online_payment_item"], null);
